/**
 * useAuth hook.
 *
 * Provides authentication state and actions to React components.
 * In Phase 1 this uses React state + context (see AuthContext).
 * Phase 2 will add persistence (refresh token in httpOnly cookie).
 */

import { useContext } from 'react';
import { AuthContext } from '../lib/auth-context';

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return ctx;
}
